import { inject, Service } from '@angular/core';
import { AnalyticsService } from '@app/core/services/mixpanel/analytics.service';

export interface IViewConfigurationTrackingContext {
  configType: () => string;
}

export interface IViewConfigurationVisibilityTrackingContext
  extends IViewConfigurationTrackingContext {
  viewVisibility: string;
}

@Service()
export class Ag1ViewConfigurationMixpanelEventTrackingService {
  private _analyticsService = inject(AnalyticsService);

  private _track(
    eventName: string,
    context: IViewConfigurationTrackingContext,
  ): void {
    this._analyticsService.track(eventName, {
      feature: context.configType(),
    });
  }

  trackSaveAView(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: Save a View', context);
  }

  trackViewName(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: View name', context);
  }

  trackViewVisibility(
    context: IViewConfigurationVisibilityTrackingContext,
  ): void {
    this._analyticsService.track('View Configuration: View Visibility', {
      feature: context.configType(),
      viewVisibility: context.viewVisibility,
    });
  }

  trackSaveView(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: Save View', context);
  }

  trackEditView(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: Edit View', context);
  }

  trackUpdateView(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: Update View', context);
  }

  trackDeleteView(context: IViewConfigurationTrackingContext): void {
    this._track('View Configuration: Delete View', context);
  }

  trackDeleteViewConfirmation(
    context: IViewConfigurationTrackingContext,
  ): void {
    this._track('View Configuration: Delete View Confirmation', context);
  }

  trackViewConfigurationDropdown(
    context: IViewConfigurationTrackingContext,
  ): void {
    this._track('View Configuration: View configuration drop-down', context);
  }
}
